import React from "react";

/**
 * Reusable InfoGrid for displaying key-value pairs in a grid layout
 */
const InfoGrid = ({ fields = [], columns = "grid-cols-2", className = "" }) => (
  <div className={`grid ${columns} gap-3 ${className}`}>
    {fields.map(({ l, v, label, value }) => {
      const displayLabel = l || label;
      const displayValue = v || value;
      
      return (
        <div key={displayLabel} className="bg-slate-50/80 rounded-lg p-3 border border-slate-100/50">
          <div className="text-[10px] text-slate-500 mb-0.5 tracking-wider uppercase font-bold">{displayLabel}</div>
          <div className="text-xs font-semibold text-brand-dark truncate">{displayValue || "—"}</div>
        </div>
      );
    })}
  </div>
);

export default InfoGrid;
